"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Divisor = void 0;
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
var Divisor = function () {
  return react_1.default.createElement(rebass_1.Box, {
    sx: {
      width: 40,
      height: "4px",
      mx: "4px",
      backgroundColor: "blue2",
      borderRadius: 30
    }
  });
};
exports.Divisor = Divisor;